import styled from 'styled-components'
import Link from 'next/link'
import { useRouter } from 'next/router'
import Wrapper from 'common/wrapper'
import { Typography } from 'common/typography'
import authors from 'components/post/authors.json'
import AuthorInfo, { AuthorStyled } from './author-info'

const LasBlogsStyled = styled.section`
  margin: 80px 0;
  .last-blogs {
    &-item {
      h3 {
        margin: 16px 0 8px;
      }
      &:hover h3 {
        text-decoration: underline;
      }
      .blog-thumb {
        width: 100%;
      }
      margin: 40px 0;
    }
  }
  @media (min-width: 1024px) {
    margin: 128px 0;
    .last-blogs {
      &-list {
        display: flex;
        justify-content: space-between;
        overflow: auto;
        flex: 1;
        gap: 24px;
      }
      &-item {
        h3 {
          margin: 24px 0 16px;
        }
        .blog-thumb {
          width: 384px;
          height: 250px;
          object-fit: cover;
        }
        margin: 40px 0;
      }
    }
  }
`

function LastBlogAuthor({ author, date, duration }) {
  if (!author) return null
  const authorSlug = author.toLowerCase()
  const { photo, name } = authors[authorSlug]
  return (
    <AuthorStyled>
      <AuthorInfo photo={photo} name={name} date={date} duration={duration} />
    </AuthorStyled>
  )
}

function LastBlogs({ blogs }) {
  const {
    query: { slug },
  } = useRouter()
  const blogsFilter = blogs
    .slice(0, 4)
    .filter(({ slug: blogSlug }) => blogSlug !== slug)
    .slice(0, 3)
  return (
    <LasBlogsStyled>
      <Wrapper maxWidth="1200">
        <div className="last-blogs">
          <Typography
            as="h2"
            small="headline5"
            large="headline4"
            color="var(--baseNeutral)"
          >
            Ver las últimas novedades
          </Typography>
          <ul className="last-blogs-list">
            {blogsFilter.map(
              ({
                title,
                thumbnail = `https://leonidasesteban.com/api/og?title=${title}`,
                slug: blogSlug,
                author,
                date,
                duration,
              }) => (
                <li className="last-blogs-item" key={blogSlug}>
                  <Link href={`/blog/${blogSlug}`}>
                    <img
                      className="blog-thumb"
                      src={thumbnail}
                      alt={`Thumbnail del blog "${title}"`}
                      loading="lazy"
                    />
                    <Typography as="h3" small="regular" large="headline5">
                      {title}
                    </Typography>
                    <LastBlogAuthor
                      author={author}
                      date={date}
                      duration={duration}
                    />
                  </Link>
                </li>
              ),
            )}
          </ul>
        </div>
      </Wrapper>
    </LasBlogsStyled>
  )
}

export default LastBlogs
